import { render, staticRenderFns } from "./changeOwn.vue?vue&type=template&id=ffda3fd6&lang=pug"
import script from "./changeOwn.vue?vue&type=script&lang=js"
export * from "./changeOwn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports